import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="logo d-flex align-items-center">
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  padding: '8px 16px',
                  display: 'inline-block',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  maxWidth: '220px',
                  width: '100%',
                }}
              >
                <img
                  src="/assets/img/Logo-Straight.png"
                  alt="Digisoft Logo"
                  style={{
                    display: 'block',
                    maxHeight: '50px',
                    width: 'auto',
                    height: 'auto',
                    margin: '0 auto',
                  }}
                  className="img-fluid"
                />
              </div>
            </a>
            <p>Digisoft, we are dedicated to transforming the way businesses manage their financial and operational processes through our cutting-edge software solutions.</p>
            <div className="footer-contact pt-3">
              <p>Our Headquarters</p>
              <p>C712 KLJ Noida One,</p>
              <p>Sector 62 Noida, Uttar Pradesh, 201309</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 9650531116</span></p>
              <p><strong>Email:</strong> <span>connect@digisofts.com</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href=""><i className="bi bi-twitter-x"></i></a>
              <a href=""><i className="bi bi-facebook"></i></a>
              <a href=""><i className="bi bi-instagram"></i></a>
              <a href=""><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="#">Home</a></li>
              <li><a href="#">About us</a></li>
              <li><a href="#">Services</a></li>
              <li><a href="#">Terms of service</a></li>
              <li><a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#">TALLYPRIME</a></li>
              <li><a href="#">BUSY</a></li>
              <li><a href="#">CLOUD COMPUTING</a></li>
              <li><a href="#">SHARE PRO</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form action="forms/newsletter.php" method="post" className="php-email-form">
              <div className="newsletter-form">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </div>
              {/*<div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div>*/}
            </form>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p><span>Copyright © 2025 </span> <strong className="px-1 sitename">Digisoft Services</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
    {/*      Designed by <a href="#">Digisoft Services</a> Distributed By <a href="#">Digisoft Services</a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 